import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PromotionTaskListQuery } from '@upme/contracts';

// Use `.catch()` to swallow malformed URLs (e.g. legacy bookmarks) while
// still applying Zod defaults via `PromotionTaskListQuery.parse({})`.
// Pass-through is required so the inferred SEARCH type stays in sync with
// the contract — TanStack Router infers it from `validateSearch`'s return.
export const Route = createFileRoute('/_authenticated/promotion-tasks')({
  staticData: { breadcrumb: 'Продвижение' },
  validateSearch: PromotionTaskListQuery.catch(PromotionTaskListQuery.parse({})),
  component: () => <Outlet />,
});
